import angular from 'angular'

import representativeComponent from './representative.component'

export default angular.module('app.pages.investors.investorApplication.investmentEntityForm.representative', [])
  .directive('representative', representativeComponent)
